import type { ReactNode } from "react";
import { cn } from "@ncp/ui";

export function Group({ title, action, children, hint }: { title: ReactNode; action?: ReactNode; children: ReactNode; hint?: ReactNode }) {
  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between gap-2"><p className="text-[11px] font-semibold uppercase tracking-wider text-sand-600">{title}</p>{action}</div>
      {hint ? <p className="-mt-1 text-[11px] leading-snug text-muted-foreground">{hint}</p> : null}
      {children}
    </section>
  );
}

export function Toggles({ options, value, onChange, label, disabled }: { options: string[]; value: string[]; onChange: (v: string[]) => void; label: (o: string) => string; disabled?: boolean }) {
  return (
    <div className="flex flex-wrap gap-1">
      {options.map((o) => {
        const on = value.includes(o);
        return (
          <button type="button" key={o} disabled={disabled} onClick={() => onChange(on ? value.filter((x) => x !== o) : [...value, o])}
            className={cn("rounded-full border px-2 py-0.5 text-[11px] transition disabled:opacity-60", on ? "border-aegold-400 bg-aegold-50 text-aegold-800" : "border-sand-200 text-muted-foreground hover:border-aegold-300")}>
            {label(o)}
          </button>
        );
      })}
    </div>
  );
}

export function Row({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("grid grid-cols-2 gap-2", className)}>{children}</div>;
}

export function Mini({ label, children }: { label: ReactNode; children: ReactNode }) {
  return <label className="block space-y-1"><span className="text-[11px] font-medium text-sand-700">{label}</span>{children}</label>;
}
